function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import NumberFormat from 'react-number-format';

class PrintPrice extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(NumberFormat, {
        value: this.props.price,
        displayType: 'text',
        thousandSeparator: true,
        prefix: '$ ',
        decimalScale: 2,
        fixedDecimalScale: true
      });
    });
  }

}

export default PrintPrice;